import axios, { AxiosInstance } from 'axios';
import apiClient from '.';
import '../helpers/downloadFileHelper';
import analyticsClient from './analytics';

import { buildUrlViaQueryString } from './newUtils';
const generateDownloadUrl = (fileToken: string) => {
    return buildUrlViaQueryString(
        `${process.env.REACT_APP_EPHEMERALSTORE}api/v1/get_file`,
        {
            token: fileToken,
            download: true,
        }
    );
};

const getFileKey = async (
    url: string,
    endpointVersion = 'v2',
    endpointDomain: string
) => {
    const client = endpointDomain === 'analytics' ? analyticsClient : apiClient;
    try {
        return await client.get(url, { apiVersion: endpointVersion });
    } catch {
        console.error('Failed to Download');
        return { key: false };
    }
};

const getFileToken = async (key: string) => {
    try {
        const axiosInstance: AxiosInstance = axios.create({
            baseURL: process.env.REACT_APP_EPHEMERALSTORE,
            headers: {
                ...apiClient.headers,
                'Content-type': 'application/json',
            },
        });
        return await axiosInstance.post('api/v1/get_file_token', { key });
    } catch {
        console.error('Failed to Download');
        return { key: false };
    }
};

const downloadFile = async ({
    url,
    endpointVersion = 'v2',
    endpointDomain,
    fetchKey = true,
}: Record<string, any>) => {
    let key;
    if (fetchKey) {
        const response: any = await getFileKey(
            url,
            endpointVersion,
            endpointDomain
        );
        key = response?.data?.key;
    } else {
        key = url;
    }
    return downloadFileByKey(key);
};

const downloadFileByKey = async (fileKey: string) => {
    if (fileKey) {
        const response: any = await getFileToken(fileKey);
        if (response) {
            try {
                //@ts-ignore
                const windowRes = window.downloadFile(
                    generateDownloadUrl(response?.data?.file_token)
                );
                return windowRes;
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }
};

export {
    getFileKey,
    getFileToken,
    downloadFile,
    generateDownloadUrl,
    downloadFileByKey,
};
